<template>
  <div class="container">
    <h1>ページが見つかりません。</h1>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
</style>
